import { render, staticRenderFns } from "./ProjectVendorList.vue?vue&type=template&id=99e529be&scoped=true"
import script from "./ProjectVendorList.vue?vue&type=script&lang=js"
export * from "./ProjectVendorList.vue?vue&type=script&lang=js"
import style0 from "./ProjectVendorList.vue?vue&type=style&index=0&id=99e529be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e529be",
  null
  
)

export default component.exports